import epayment from './epayment_import/initializers/list';
import bankaccount from './parentpay/initializers/bankaccount';
import parentpayContact from './parentpay/initializers/contact';
import parentpayCostcentre from './parentpay/initializers/costcentre';
import parentpayPaymentitem from './parentpay/initializers/paymentitem';
import parentpayTransaction from './parentpay/initializers/transaction';
import parentpayAuth from './parentpay/initializers/auth';
import menupicker from './menupicker/initializers/menupicker';
import messages from './messaging/initializers/joinos';
import joinosOffer from './offers/initializers/edit';
import joinosCode from './joinos_codes/initializers/list';
import receiptAccounts from './receipt/initializers/accounts';

import { paymentItem as epaymentPaymentItem } from './epayment/initializers/paymentitem';
import { contact as epaymentContact } from './epayment/initializers/contact';
import epaymentTransaction from './epayment/initializers/transaction';

// import { support } from './support/initializer';

export const initializers = {
  'epayment-upload': epayment,
  'parentpay-auth': parentpayAuth,
  'parentpay-bankaccount': bankaccount,
  'parentpay-contact': parentpayContact,
  'parentpay-costcentre': parentpayCostcentre,
  'parentpay-paymentitem': parentpayPaymentitem,
  'parentpay-transaction': parentpayTransaction,
  'epayment-contact': epaymentContact,
  'epayment-paymentitem': epaymentPaymentItem,
  'epayment-transaction': epaymentTransaction,
  'menupicker': menupicker,
  'messages': messages,
  'offers': joinosOffer,
  'joinos_codes': joinosCode,
  'receipt-accounts': receiptAccounts,
//  'support': support,
};



// WEBPACK FOOTER //
// ./includes.js